import { useEffect } from 'react'

import { useMe } from '@/api/hooks'

import { startAutoplay } from './autoplay'

export function AutoplayCoordinator() {
  const { data: user } = useMe()
  useEffect(() => user ? startAutoplay() : undefined, [user?.id])
  return null
}
